﻿import { HttpClient } from "@angular/common/http";
import { Predicate, EntityQuery, FetchStrategy } from "breeze-client";
import * as _provider from './entitymanagerprovider';

export class bridge {
    constructor(private _http: HttpClient, private _entityManagerProvider: _provider.EntityManagerProvider) { }

    private isEmpty(obj: Object): boolean {
        for(var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }

        return true;
    }

    private httpPost(resourceName: string, params: Object): Promise<Object> {
        var url = this._entityManagerProvider.manager().serviceName + resourceName;
        return this._http.post(url, params).toPromise();
    }

    private httpGet<T>(resourceName: string, params: Object, sort?: string, filter?: Predicate) {
        var query = EntityQuery
            .from(resourceName);

        if (!this.isEmpty(params)) {
            query = query.withParameters(params);
        }

        return this.executeQuery<T>(query, sort, filter);
    }

    private postWithParams<T>(resourceName: string, params: Object, sort?: string, filter?: Predicate) {
        var postParams = { $method: 'POST', $encoding: 'JSON', $data: params };
        return this.getWithParams<T>(resourceName, postParams, sort, filter);
    }

    private getWithParams<T>(resourceName: string, params: Object, sort?: string, filter?: Predicate) {
        var query = EntityQuery
            .from(resourceName)
            .withParameters(params);

        return this.executeQuery<T>(query, sort, filter);
    }

    private executeQuery<T>(query: EntityQuery, sort?: string, filter?: Predicate) {
        if (filter)
            query = query.where(filter);

        if (sort)
            query = query.orderBy(sort);

        return this._entityManagerProvider.manager()
            .executeQuery(query.using(FetchStrategy.FromServer))
            .then((data) => {
                return <T[]><any>data.results;
            });
    }
    
    lookups( sort?: string, filter?: Predicate) {
        var params = {  };
        
        return this.httpGet<any>('lookups', params, sort, filter)
    }
    
    keepAlive( sort?: string, filter?: Predicate) {
        var params = {  };
        
        return this.httpGet<string>('keepAlive', params, sort, filter)
    }
    
    authIsAdmin( sort?: string, filter?: Predicate) {
        var params = {  };
        
        return this.httpGet<boolean>('authIsAdmin', params, sort, filter)
    }
    
    getWorkspaceRights( sort?: string, filter?: Predicate) {
        var params = {  };
        
        return this.httpGet<model.workspaceRightDto>('getWorkspaceRights', params, sort, filter)
    }
    
    browse(library: string, workspace: number, id: number,  sort?: string, filter?: Predicate) {
        var params = { library: library, workspace: workspace };
        if (id) params['id'] = id;
        return this.httpGet<model.folder>('browse', params, sort, filter)
    }
    
    documentView(library: string, id: number,  sort?: string, filter?: Predicate) {
        var params = { library: library, id: id };
        
        return this.httpGet<model.document>('documentView', params, sort, filter)
    }
    
    documentDownload(library: string, id: number,  sort?: string, filter?: Predicate) {
        var params = { library: library, id: id };
        
        return this.httpGet<any>('documentDownload', params, sort, filter)
    }
    
    getAdminWorkspaceRights( sort?: string, filter?: Predicate) {
        var params = {  };
        
        return this.httpGet<model.workspaceRight>('getAdminWorkspaceRights', params, sort, filter)
    }
    
    searchWorkspace(library: string, workspace: number, query: string,  sort?: string, filter?: Predicate) {
        var params = { library: library, workspace: workspace, query: query };
        
        return this.httpGet<model.folder>('searchWorkspace', params, sort, filter)
    }
    
}
